import {Injectable, Optional} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import {HttpRequest, HttpClient, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {Cookie} from 'ng2-cookies/ng2-cookies';
import { TranslateService } from '@ngx-translate/core';
import { BackendTranslateService } from '../helper/backend-translate.service';

@Injectable()
export class ApiService {
  private baseURl = '';
  public vendorSpecificReports: any = {};

  constructor(
    private http: Http,
    private httpClient: HttpClient,
    private translate: TranslateService,
    private backendTranslate: BackendTranslateService) {
  }

  private setHeaders(): Headers {
    const headersConfig = {};
    return new Headers(headersConfig);
  }

  generateUid(fileName, captcha): Observable<any> {
    return this.http.get(`${environment.baseURL}${environment.parser}/generate-uid-s3?fileName=${fileName}${captcha != '' ? '&captcha=' + captcha : ''}`, {headers: this.setHeaders()})
      .map((res: Response) => {
        return res.json();
      });
  }

  generateCaptchaImg(): Observable<any> {
    return this.http.get(`${environment.baseURL}${environment.zoho}/zohocapthaimage`)
      .map((res: Response) => {
        if(res.ok) {
          return res.text();
        } else {
          return null;
        }
      });
  }

  getCaptchaImgURL(): string {
    return "" + environment.baseURL + environment.zoho + "/zohocaptchaimage?refreshDateTime=" + new Date().getTime();
  }

  generatePaymentInvoice(userEmail : string, singlePayment : boolean): Observable<boolean> {
    const req = {
      userEmail: userEmail,
      singlePayment: singlePayment
    };
    return this.http.post(`${environment.baseURL}${environment.zoho}/payment`, req)
      .map((res) => {
          if(res.ok) {
            return true;
          } else {
            return false;
          }
      });
  }

  get(startIndex, count, text, column, order): Observable<any> {
    return this.http.get(`${this.baseURl}/getData?startIndex=${startIndex}&count=${count}&text=${text}&sortColumn=${column}&sortDirection=${order}`, {headers: this.setHeaders()})
      .map((res: Response) => {
        return res.json();
      });
  }

  upload(uidData, ruid, file): Observable<any> {
      if (uidData.gcUploadURL) {
          const formData = this.createGoogleCloudFormData(uidData, ruid, file);
          const req = new HttpRequest('PUT', `${uidData.gcUploadURL}`, file, {
              reportProgress: true,
              //Suppress Content-Type detection as it's used in signature, and I found to way to remove it from HttpRequest
              headers: new HttpHeaders({'Accept': '*/*', 'Content-Type':'text/plain'}),
              responseType: 'text',
          });

          return this.httpClient.request(req);
      } else {
          const formData = this.createS3FormData(uidData, ruid, file);
          const req = new HttpRequest('POST', `${environment.AmazonS3}`, formData, {
              reportProgress: true,
              headers: new HttpHeaders({Accept: '*/*'}),
              responseType: 'text'
          });
          return this.httpClient.request(req);
      }

  }
  
    createGoogleCloudFormData(data, ruid, file) {
        const formData = new FormData();
        formData.append('file', file);
        return formData;
    }


    createS3FormData(data, ruid, file) {
        const formData = new FormData();
        formData.append('key', data.key + ruid);
        formData.append('acl', data.acl);
        formData.append('policy', data.policy);
        formData.append('AWSAccessKeyId', data.AWSAccessKeyId);
        formData.append('success_action_status', data.success_action_status);
        formData.append('signature', data.signature);
        formData.append('file', file);
        return formData;
    }


  parseData(fileName): Observable<any> {
    return this.http.get(`${environment.baseURL}${environment.parser}`, {headers: new Headers({'Accept': 'text/plain'})})
      .map((res: Response) => {
        return {contextId: res.text(), fileName: fileName};
      });
  }

  parseDataPost(ruid, fileName, contextId): Observable<any> {
    return this.http.post(`${environment.baseURL}${environment.parser}?ruid=${encodeURIComponent(ruid)}&fileName=${encodeURIComponent(fileName)}&contextId=${contextId}`, '')
      .map((res: Response) => {
        return res.text();
      });
  }

  getSummary(ruid) {
    return this.http.get(`${environment.baseURL}${environment.report}/summary?ruid=${encodeURIComponent(ruid)}`)
      .map((res: Response) => {
        return res.json();
      });
  }

  getErrors(ruid) {
    return this.http.get(`${environment.baseURL}${environment.report}/errors?ruid=${encodeURIComponent(ruid)}`)
      .map((res: Response) => {
        return res.json();
      });
  }

  getLicenseUsage(ruid) {
    return this.http.get(`${environment.baseURL}${environment.reportChart}/license-usage?ruid=${encodeURIComponent(ruid)}`)
      .map((res: Response) => {
        return res.json();
      });
  }

  getDenialByDay(ruid) {
    return this.http.get(`${environment.baseURL}${environment.reportChart}/denials-by-day?ruid=${encodeURIComponent(ruid)}`)
      .map((res: Response) => {
        return res.json();
      });
  }

  getDenials(ruid) {
    return this.http.get(`${environment.baseURL}${environment.report}/denials?ruid=${encodeURIComponent(ruid)}`)
      .map((res: Response) => {
        return res.json();
      });
  }

  getOpenSessions(ruid) {
    return this.http.get(`${environment.baseURL}${environment.report}/open-sessions?ruid=${encodeURIComponent(ruid)}`)
      .map((res: Response) => {
        return res.json();
      });
  }

  getClosedSessions(ruid) {
    return this.http.get(`${environment.baseURL}${environment.report}/closed-sessions?ruid=${encodeURIComponent(ruid)}`)
      .map((res: Response) => {
        return res.json();
      });
  }

  getUsers(ruid) {
    return this.http.get(`${environment.baseURL}${environment.report}/users?ruid=${encodeURIComponent(ruid)}`)
      .map((res: Response) => {
        return res.json();
      });
  }

  getChartData(ruid, type) {
    return this.http.get(`${environment.baseURL}${environment.reportChart}/type/${type}?ruid=${encodeURIComponent(ruid)}`)
      .map((res: Response) => {
        return res.json();
      });
  }

  getFeatures(ruid) {
    return this.http.get(`${environment.baseURL}${environment.report}/features?ruid=${encodeURIComponent(ruid)}`)
      .map((res: Response) => {
        return res.json();
      });
  }

  getVendorSpecificReports(ruid) {
    return this.http.get(`${environment.baseURL}${environment.report}/vendor-specific?ruid=${encodeURIComponent(ruid)}`)
      .map((res) => {
        return this.vendorSpecificReports = res.json();
      });
  }

  vendorReports(SLOG) {
    return this.vendorSpecificReports[SLOG];
  }

  getCSV(ruid, type, xls) {
    const jsessionid = Cookie.get('JSESSIONID');
    window.open(`${environment.baseURL}${environment.report}/csv;jsessionid=${jsessionid}?`
        + `ruid=${encodeURIComponent(ruid)}&reportType=${type}${xls != '' ? '&xls=true' : ''}`);
  }


  uniqueName(ruid, fileName) {
      //This code is duplicated in Java GenerateUidS3Controller
    const pos = fileName.lastIndexOf('.');
    return encodeURI(fileName.substring(0, pos) + '.' + ruid + fileName.substring(pos));
  }

  getMessageFromError(error, defaultMessage) {
      let jsonError = null;

      if (error && error.error) {
          try {
              jsonError = JSON.parse(error.error).message;
          } catch (exc) {
              console.log(exc);
          }
      }

      if (jsonError == null && error && error.json) {
          try {
            jsonError = error.json().message;
          } catch (exc) {
              console.log(exc);
          }
      }

      if (jsonError == null && error && error._body) {
          try {
              jsonError = JSON.parse(error._body).message;
          } catch (exc) {
              console.log(exc);
          }
      }

      if (jsonError == null) {
          jsonError = defaultMessage;
      }
      let backendErrorTranslate = this.backendTranslate.translateMessage(jsonError);

      if(backendErrorTranslate.includes('apiMessages.')) {
        return jsonError
      } else {
        return backendErrorTranslate
      }

  }

    getAWSMessage(errorResponse: HttpErrorResponse, currentUser: any) {
      let awsMessage = null;
      try {
          const oParser = new DOMParser();
          const oDOM = oParser.parseFromString(errorResponse.error, 'text/xml');
          const code = oDOM.getElementsByTagName('Code')[0];
          console.error(code);
          const message = oDOM.getElementsByTagName('Message')[0];
          console.error(message);
          if (code && code.textContent === 'EntityTooLarge') {
			let s3MaxUploadSize = this.getS3SuitableMaxUploadSize(currentUser);
			awsMessage = this.translate.instant('common.awsErrorFileSizeLimit') + s3MaxUploadSize;
          } else if (message) {
              awsMessage = message.textContent;
          }
      } catch (exc) {
          console.log(exc);
      }
      //console.log(awsMessage);
      return awsMessage;
    }

    getErrorKey(error) {
        let jsonError = null;

        try {
            jsonError = error.json().error;
        } catch (exc) {
            console.log(exc);
        }

        if (jsonError == null) {
            try {
                jsonError = JSON.parse(error._body).error;
            } catch (exc) {
                console.log(exc);
            }
        }

        if (jsonError == null) {
            jsonError = 'GENERIC';
        }

        return jsonError;
    }
    
    getS3SuitableMaxUploadSize(currentUser: any) : string {
	    let s3MaxUploadSize = `${environment.AmazonS3UploadLimit}`;
      if(currentUser && currentUser.pk && currentUser.paid && currentUser.premium) {
        s3MaxUploadSize = `${environment.AmazonS3PremiumUploadLimit}`;
      } else if(currentUser && currentUser.pk && currentUser.paid && !currentUser.premium) {
        s3MaxUploadSize = `${environment.AmazonS3AdvancedUploadLimit}`;
      } else if(currentUser && currentUser.pk && !currentUser.paid && !currentUser.premium) {
        s3MaxUploadSize = `${environment.AmazonS3BasicUploadLimit}`;
      }
      return s3MaxUploadSize;
    }
}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/services/api.service.ts